import React from 'react';

export const capitalizeFirstChar = (text?: string) => {
    if (!text) {
        return '';
    }

    return text.charAt(0).toUpperCase() + text.slice(1);
};

export const firstCharToLowCase = (text?: string) => {
    if (!text) {
        return '';
    }

    return text.charAt(0).toLowerCase() + text.slice(1);
};

export const splitTextWithBr = (str: string) => {
    return str.split('<br/>').map((part, index) => (
        <React.Fragment key={index}>
            {part}
            {index < str.split('<br/>').length - 1 && <br />}
        </React.Fragment>
    ));
};

export const splitTextWithNewLineSymbols = (str: string) => {
    return str.replace(/\\r?\\n/gu, '<br/>');
};

export const splitSentencesWithNewLines = (text: string) => {
    if (!text) {
        return null;
    }

    const sentences = text.split(/([.!?])\s+/u).reduce<string[]>((acc, part, index, arr) => {
        if (0 === index % 2) {
            const sentence = part + (arr[index + 1] ?? '');
            const trimmed = sentence.trim();
            if (trimmed) {
                acc.push(trimmed);
            }
        }
        return acc;
    }, []);

    return sentences.map((sentence, index) => (
        <React.Fragment key={index}>
            {sentence}
            {index < sentences.length - 1 && <br />}
        </React.Fragment>
    ));
};
